import type {
  InviteUserAccessOnlySchema,
  ScopePayload,
  ExclusionPayload,
} from '../models';

export function buildScopesAndExclusionsFromAccess(data: {
  operators: InviteUserAccessOnlySchema['operators'];
  commerces: InviteUserAccessOnlySchema['commerces'];
  branches: InviteUserAccessOnlySchema['branches'];
}): { scopes: ScopePayload[]; exclusions: ExclusionPayload[] } {
  const scopes: ScopePayload[] = [];
  const exclusions: ExclusionPayload[] = [];

  const { operators, commerces, branches } = data;

  if (operators.includeAll) {
    scopes.push({ scopeType: 'operator', scopeId: null });
    operators.excluded.forEach((id) => {
      exclusions.push({ scopeType: 'operator', scopeId: id });
    });
    operators.subOperators.excluded.forEach((id) => {
      exclusions.push({ scopeType: 'operator', scopeId: id });
    });
  } else {
    operators.selected.forEach((id) => {
      scopes.push({ scopeType: 'operator', scopeId: id });
    });
    if (operators.subOperators.includeAll) {
      operators.subOperators.excluded.forEach((id) => {
        exclusions.push({ scopeType: 'operator', scopeId: id });
      });
    } else {
      operators.subOperators.selected.forEach((id) => {
        scopes.push({ scopeType: 'operator', scopeId: id });
      });
    }
  }

  if (commerces.includeAll) {
    scopes.push({ scopeType: 'commerce', scopeId: null });
    commerces.excluded.forEach((id) => {
      exclusions.push({ scopeType: 'commerce', scopeId: id });
    });
  } else {
    commerces.selected.forEach((id) => {
      scopes.push({ scopeType: 'commerce', scopeId: id });
    });
  }

  if (branches.includeAll) {
    scopes.push({ scopeType: 'branch', scopeId: null });
    branches.excluded.forEach((id) => {
      exclusions.push({ scopeType: 'branch', scopeId: id });
    });
  } else {
    branches.selected.forEach((id) => {
      scopes.push({ scopeType: 'branch', scopeId: id });
    });
  }

  return { scopes, exclusions };
}
